import {BaseUrlConstant} from "@/server/base-url.constant";

const url = {
  SIGANTURE: `${BaseUrlConstant.EZLEARN_WECHAT_BASE_SERVICE}/signature`,
  GET_ACCESS_TOKEN_BY_CODE: `${BaseUrlConstant.EZLEARN_WECHAT_BASE_SERVICE}/access-token`
}

export default url;
